import {
  SwapOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  ZoomOutOutlined,
  ZoomInOutlined,
} from '@ant-design/icons/lib'
import { Space, Image } from 'antd/es'
import React from 'react'

import { PostResponse } from '@/model/post'


export default function PostImage({ listItem }: { listItem: PostResponse }) {
  const imgUrlArr: string[] = listItem.post.media.split(',')

  return (
    <Image.PreviewGroup
      preview={{
        toolbarRender: (
          _,
          {
            transform: { scale },
            actions: {
              onFlipY,
              onFlipX,
              onRotateLeft,
              onRotateRight,
              onZoomOut,
              onZoomIn,
            },
          },
        ) => (
          <Space size={12} className="toolbar-wrapper">
            <SwapOutlined rotate={90} onClick={onFlipY} />
            <SwapOutlined onClick={onFlipX} />
            <RotateLeftOutlined onClick={onRotateLeft} />
            <RotateRightOutlined onClick={onRotateRight} />
            <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut} />
            <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn} />
          </Space>
        ),
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
          gridGap: 16,
        }}
      >
        {imgUrlArr.map((item, index) => (
          <Image
            key={index}
            src={item}
            alt={item}
            width={'100%'}
            height={'auto'}
            referrerPolicy={'no-referrer'}
          />
        ))}
      </div>
    </Image.PreviewGroup>
  )
}
